import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as admin from '../../../admin'
import type * as me from '../../../me'
import type { Feature } from '../feature'

/**
 * Refreshes Admin Center state after a Quiver deployment creates apps.
 *
 * Quiver deployment can create app records outside the admin app collection's
 * create flow, so the current list and access tree must be refreshed explicitly.
 */
export const refreshAdminAppsOnDeploySuccess = store.effects.create(
  (feature: Feature, appsEc: admin.apps.Collection, meFeature: me.Feature) =>
    feature.actions.deploy.success
      .observe()
      .pipe(
        rxjs.mergeMap(action =>
          rxjs.of(
            meFeature.actions.get.from(action).create(),
            appsEc.plugins.currentListPlugin.feature.actions.load
              .from(action)
              .create(),
          ),
        ),
      ),
)
